<script setup lang="ts">
import { useIsStuck } from "@/shared/utils/useIsStuck.ts";
import { ref } from "vue";

const footerRef = ref<HTMLElement | null>(null);
const { isStuck } = useIsStuck(footerRef, {
  position: "bottom",
});
</script>

<template>
  <div
    class="sticky bottom-0 -mx-5 mt-0 -mb-[calc(1.25rem_+_env(safe-area-inset-bottom))] pb-[env(safe-area-inset-bottom)] z-10 bg-transparent border-t border-transparent transition-all"
    ref="footerRef"
    :class="{
      'bg-background backdrop-blur-lg bg-opacity-25  border-t-gray-300/50':
        isStuck,
    }"
  >
    <div class="flex px-5 py-3 justify-center">
      <slot />
    </div>
  </div>
</template>
